import api from '../../../services/api';
import {
  setListings,
  setLoading,
  setError,
  setPagination,
  setFilters,
  clearFilters,
  setExpandedRowKeys
} from '../reducers';
import { FILTER_TYPES } from '../constants/filterTypes';

// Hàm lấy danh sách listings từ API với phân trang
export const fetchListings = (page = 1, pageSize = 25) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    // Lấy thông tin filter hiện tại
    const { filters } = getState().listings;

    // Tạo query params cho API request
    const queryParams = new URLSearchParams();
    queryParams.append('page', page);
    queryParams.append('pageSize', pageSize);

    // Thêm các filter vào query params nếu có
    if (filters.searchText) {
      queryParams.append('searchText', filters.searchText);
    }

    if (filters.selectedFulfillmentChannel && filters.selectedFulfillmentChannel !== 'all') {
      queryParams.append('fulfillmentChannel', filters.selectedFulfillmentChannel);
    }

    if (filters.selectedStatus && filters.selectedStatus !== 'all') {
      queryParams.append('status', filters.selectedStatus);
    }

    if (filters.selectedSellerAccount) {
      if (Array.isArray(filters.selectedSellerAccount) && filters.selectedSellerAccount.length > 0) {
        // Handle multiple seller accounts
        filters.selectedSellerAccount.forEach(accountId => {
          queryParams.append('sellerAccountId', accountId);
        });
      } else if (filters.selectedSellerAccount !== 'all') {
        queryParams.append('sellerAccountId', filters.selectedSellerAccount);
      }
    }

    const response = await api.get(`/inventory/listings?${queryParams.toString()}`);
    
    dispatch(setListings(response.data.rows));
    dispatch(setPagination({
      current: response.data.pagination.page,
      pageSize: response.data.pagination.pageSize,
      total: response.data.pagination.total
    }));
    
  } catch (error) {
    console.error('Error fetching listings:', error);
    dispatch(setError(error.message));
  } finally {
    dispatch(setLoading(false));
  }
};

// Hàm lấy children của một listing
export const fetchListingChildren = (parentSku) => async (dispatch) => {
  try {
    const response = await api.get(`/inventory/listings/${parentSku}/children`);
    return response.data;
  } catch (error) {
    console.error('Error fetching listing children:', error);
    return [];
  }
};

// Generic filter change handler
export const handleFilterChange = (filterType, value) => (dispatch) => {
  const filterUpdate = {};
  filterUpdate[filterType] = value;
  dispatch(setFilters(filterUpdate));
};

// Individual filter change handlers for backward compatibility
export const handleSearchChange = (searchText) => (dispatch) => {
  dispatch(setFilters({ [FILTER_TYPES.SEARCH]: searchText }));
};

export const handleFulfillmentChannelChange = (selectedFulfillmentChannel) => (dispatch) => {
  dispatch(setFilters({ [FILTER_TYPES.FULFILLMENT_CHANNEL]: selectedFulfillmentChannel }));
};

export const handleStatusChange = (selectedStatus) => (dispatch) => {
  dispatch(setFilters({ [FILTER_TYPES.STATUS]: selectedStatus }));
};

export const handleSellerAccountChange = (selectedSellerAccount) => (dispatch) => {
  dispatch(setFilters({ [FILTER_TYPES.SELLER_ACCOUNT]: selectedSellerAccount }));
};

export const handleClearFilters = () => (dispatch) => {
  dispatch(clearFilters());
};

export const applyFilters = () => (dispatch, getState) => {
  const { pagination } = getState().listings;
  dispatch(fetchListings(1, pagination.pageSize)); // Reset to first page
};

export const handlePaginationChange = (page, pageSize) => (dispatch) => {
  dispatch(setPagination({ current: page, pageSize }));
  dispatch(fetchListings(page, pageSize));
};

export const handleExpandedRowsChange = (expandedRowKeys) => (dispatch) => {
  dispatch(setExpandedRowKeys(expandedRowKeys));
};